import { Clock2 } from "@assets";
import { Row } from "@components/Flex";
import { BodySmall } from "@components/Typography";
import { useStyles } from "./styles";
import { InProgressBannerProps } from "./types";

export const InProgressBanner = ({
  title,
  subtitle,
  ctaTitle,
  ctaOnClick,
}: InProgressBannerProps) => {
  const styles = useStyles();
  return (
    <div style={styles.container}>
      <Row style={styles.content}>
        <Row>
          <Clock2 />
          <BodySmall style={styles.title}>{title}</BodySmall>
        </Row>

        <BodySmall style={styles.subtitle}>{subtitle}</BodySmall>
        <div style={styles.contactSupportContainer} onClick={ctaOnClick}>
          <BodySmall style={styles.contactSupport}>{ctaTitle}</BodySmall>
        </div>
      </Row>
    </div>
  );
};
